import {
  Box,
  Image,
  MediaBox,
  MediaFlex,
  Typography,
} from "@jewlr/storybook/core"
import React from "react"
import styled from "styled-components"

const Container = styled(Box).attrs({
  bg: { _: "none", tablet: "#f9f9f9" },
})``

const Wrapper = styled(Box).attrs({
  contain: true,
  pb: { _: 3, tablet: 6 },
  pt: { tablet: 6 },
  px: 2,
})``

const Title = styled(Typography).attrs({
  as: "h2",
  fontSize: { _: "18px", tablet: "24px" },
  fontWeight: "500",
  lineHeight: { _: "24px", tablet: "30px" },
  mb: { _: 3, tablet: "36px" },
  textAlign: "center",
  textTransform: "capitalize",
})``

const EthicallySourced = () => (
  <Container>
    <Wrapper>
      <Box py="10px">
        <Title>
          Handcrafted In The US And Canada Using Ethically Sourced Materials
        </Title>
        <MediaBox lessThan="tablet">
          <Image
            alt="Handcrafted 3"
            ratio="auto 286 / 271"
            src={require("images/product/info/quality_made_3.png")}
            width="100%"
          />
        </MediaBox>
        <MediaFlex
          gap={{ desktop: 4, tablet: 3 }}
          greaterThanOrEqual="tablet"
          justifyContent="center"
        >
          <Image
            alt="Handcrafted 1"
            ratio="auto 283 / 271"
            src={require("images/product/info/quality_made_1.png")}
            width={{ _: "100%", desktop: "300px", tablet: "200px" }}
          />
          <Image
            alt="Handcrafted 2"
            ratio="auto 286 / 271"
            src={require("images/product/info/quality_made_2.png")}
            width={{ _: "100%", desktop: "300px", tablet: "200px" }}
          />
          <Image
            alt="Handcrafted 3"
            ratio="auto 286 / 271"
            src={require("images/product/info/quality_made_3.png")}
            width={{ _: "100%", desktop: "300px", tablet: "200px" }}
          />
        </MediaFlex>
      </Box>
    </Wrapper>
  </Container>
)

export default EthicallySourced
